import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Montserrat: latin + cyrillic, веса 300/400/500/600 (шкала бренда).
import '@fontsource/montserrat/latin-300.css';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/cyrillic-300.css';
import '@fontsource/montserrat/cyrillic-400.css';
import '@fontsource/montserrat/cyrillic-500.css';
import '@fontsource/montserrat/cyrillic-600.css';

// Дизайн-токены бренда (CSS-переменные + утилиты), затем верстка приложения.
import '@luum/shared/tokens.css';
import './styles/global.css';

import { App } from './App.js';
import { initTheme } from './theme.js';
import { initI18n } from './i18n/index.js';

initTheme();
initI18n();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root не найден в index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker — только в проде: в dev он мешает HMR.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}
